import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { WorkItemLens } from 'common/workitems/models/workitem-lens';
import { WebConsoleConfigInterface } from '../web-console-container/web-console-config.interface';
import { BcConfigService } from 'common/config/provider';
import { BcAuth } from 'common/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lens',
  templateUrl: './lens.component.html',
  styleUrls: ['./lens.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LensComponent implements OnInit {
  @Input()
  workItem: WorkItemLens;

  webConsoleConfig: WebConsoleConfigInterface;

  constructor(
    private bcConfig: BcConfigService,
    private bcAuth: BcAuth,
    private translate: TranslateService) {
  }

  ngOnInit() {
    this.webConsoleConfig = {
      uiMode: 'Lens',
      language: `${this.translate.currentLang}`,
      integrationOptions: {
        navigation: {
          behavior: 'portpubsub',
          initialRoute: this.workItem.elmRoute || '#/create'
        },
        workflow: 'single',
        rescueHeader: false, // Deprecated
        includeStylesheets: true, // Deprecated
        minWidth: 700,
        minHeight: 670
      },
      /* Deprecated userInfo */
      userInfo: {
        name: '',
        userRole: '',
        myAccountPageUrl: '',
        changePasswordUrl: '',
        lensAudioEnabled: false
      },
      connectionSettings: {
        heartbeatRate: 3,
        timeout: 10,
        serviceUrl: this.bcConfig.current.webConsoleServiceUrl,
        authorization: {
          mode: 'BoldSessionCookie',
          endpoint: `${this.bcConfig.getRestApiHost()}/aid/${this.bcAuth.getSessionAccountId()}`,
          cookieDomain: `${this.bcConfig.current.cookieDomain}`
        }
      }
    };
  }
}
